// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__3mTxq","logo":"Logo_logo__vDBPO","verticalLogo":"Logo_verticalLogo__4MbRC"};